module.exports = __webpack_public_path__ + "static/media/1.4e39f883.png";